import React, {useEffect, useState} from "react";

import styles from "./DottedItemList.module.css";
import DottedItem from "../dotted-item/DottedItem";
import calculateShift from "../../utils/expertise-dotted-items/calculate-items-shift.helper";

const DottedItemList = ({
    selectedTechnologies,
    dottedItems,
    isPink,
    activeItemIndex,
    title
}) => {
    const maxSingleColumnSize = 6
    const [leftColumn, setLeftColumn] = useState([])
    const [rightColumn, setRightColumn] = useState(null)

    useEffect(() => {
        if(dottedItems.length < maxSingleColumnSize) {
            setLeftColumn(dottedItems)
        } else {
            const halfArrayLength = Math.ceil(dottedItems.length / 2)
            setLeftColumn(() => dottedItems.slice(0, halfArrayLength))
            setRightColumn(() => dottedItems.slice(halfArrayLength))
        }
    }, [dottedItems])

    const shift =
        activeItemIndex || activeItemIndex === 0
            ? {
                  position: "absolute",
                  top: calculateShift(selectedTechnologies, activeItemIndex) + "px",
              }
            : null;

    return (
        <div>
            {title && (
                <div className={styles.header}>
                    <span className={styles.title}>{title}</span>
                    <span className={styles.divider}>
                            ••••••••••••••••••••••••••••••••••••••
                        </span>
                </div>
            )}
            <div className={styles.itemsWrapper}>
                <div className={styles.itemList}>
                    {leftColumn.map((item) => {
                        return <DottedItem item={item.title} key={item.id} isPink={isPink} />;
                    })}
                </div>
                {rightColumn && <div className={styles.itemList}>
                    {rightColumn.map((item) => {
                        return <DottedItem item={item.title} key={item.id} isPink={isPink} />;
                    })}
                </div>}
            </div>
        </div>
    );
};

export default DottedItemList;
